import React, { useState, useEffect } from "react";
import axios from "axios";
import { Redirect } from "react-router-dom";
import { UserConsumer } from "../../../UserContext";
import "bootstrap/dist/css/bootstrap.min.css";
import { Col, Button, Input, Row, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { ReimbursementAPIs } from "../../MyReimbursement/MyReimbursementAPI's";
import { AlertPopups } from "../../../components/AlertPopups";
import Header from "../../../components/Header";
import PageLoader from "../../../components/PageLoader";
import classnames from 'classnames';

const ReimbursementPolicyUpload = () => {
  const [attachment, setAttachment] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('1'); // State to manage the active tab
  const [history, setHistory] = useState([]);
  let token = null;

  useEffect(() => {
    if (activeTab === '2') {
      // Fetch history when the history tab is active
      axios
        .get(`${ReimbursementAPIs.GetReimbursementPolicyHistory}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(({ data }) => setHistory(data))
        .catch(error => console.error("Error fetching history", error));
    }
  }, [activeTab]);

  const handleDownload = (fileId, fileName) => {
    axios({
      url: `${ReimbursementAPIs.DownloadFile}/${fileId}`, // Adjust endpoint path as needed
      method: "GET",
      responseType: "blob", // Important for binary data
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((error) => {
        console.error("Error downloading the file", error);
        AlertPopups.ErrorAlert.fire({
          text: "Failed to download the file",
        });
      });
  };
  
  
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!attachment) {
      AlertPopups.ErrorAlert.fire({
        text: "Please attach a file before uploading.",
      });
      return;
    }

    const allowedFileTypes = ["application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"];
    if (!allowedFileTypes.includes(attachment.type)) {
      AlertPopups.ErrorAlert.fire({
        text: "Please attach an Excel file (.xls or .xlsx) before uploading.",
      });
      return;
    }

    setIsLoading(true);
    const formData = new FormData();
    formData.append("file", attachment);

    axios
      .post(`${ReimbursementAPIs.UploadReimbursementPolicy}`, formData, {
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
      })
      .then(({ status }) => {
        setIsLoading(false);
        if (status === 200) {
          AlertPopups.successAlert.fire({
            text: "Policy Added Successfully",
          });
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else {
          AlertPopups.ErrorAlert.fire({
            text: "Failed to upload file",
          });
        }
      })
      .catch(error => {
        setIsLoading(false);
        let errorMessage = "Failed to upload file";
        if (error.response && error.response.data ) {
          errorMessage = error.response.data;
        }
        AlertPopups.ErrorAlert.fire({
          text: errorMessage,
        });
      });
  };

  const toggleTab = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    isLoading ? (
      <PageLoader />
    ) : (
      <UserConsumer>
        {(userDetails) => {
          token = userDetails.token;
          return userDetails.empRole.includes("5") ? (
            <div className="container-fluid pl-3 pr-3">
              <Header title="Reimbursement Policy" headerBorder="false" />

              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '1' })}
                    onClick={() => { toggleTab('1'); }}
                  >
                    Upload Policy
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '2' })}
                    onClick={() => { toggleTab('2'); }}
                  >
                    Upload History
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                  <form>
                    <div className="formInfoContainer my-3">
                      <Col>
                        <Row className="py-2 px-2">
                          <Col md={3} lg={2}>
                            <div className="formDetailHeader">
                              <div>
                                Upload Policy Sheet
                                <span className="required">*</span>
                              </div>
                            </div>
                          </Col>
                          <Col sm={9} id="attachment-align">
                            <Input
                              type="file"
                              style={{ marginTop: '8px' }}
                              name="attachment"
                              id="attachment"
                              accept=".xlsx, .xls"
                              className="overflow-hidden"
                              onChange={(e) => setAttachment(e.target.files[0])}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </div>
                    <div className="btns">
                      <Button
                        type="submit"
                        className="submit-report leftBtn"
                        onClick={handleSubmit}
                      >
                        Upload
                      </Button>
                    </div>
                  </form>
                  <div>
                    <a href="/SampleFile/ReimbursementPolicy.xlsx" download>
                      Download Sample Excel Sheet
                    </a>
                  </div>
                </TabPane>
                <TabPane tabId="2">
                  <div className="historyContainer my-3">
                    <h5>Upload History</h5>
                    {history.length > 0 ? (
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                           
                            <th>Uploaded Date</th>
                            <th>Uploaded By</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {history.map((item, index) => (
                            <tr key={index}>
                            
                              <td>{new Date(item.uploadedDate).toLocaleDateString()}</td>
                              <td>{item.uploadedBy}</td>
                              <td>
  <button
    onClick={() => handleDownload(item.id, item.fileName)}
    className="btn btn-link"
  >
    Download
  </button>
</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <p>No files uploaded yet.</p>
                    )}
                  </div>
                </TabPane>
              </TabContent>
            </div>
          ) : (
            <Redirect to="/MyDashboard" />
          );
        }}
      </UserConsumer>
    )
  );
};

export default ReimbursementPolicyUpload;
